import { render, staticRenderFns } from "./TheMainMenuItem.vue?vue&type=template&id=9f2d8152&"
import script from "./TheMainMenuItem.vue?vue&type=script&lang=ts&"
export * from "./TheMainMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports